import React from 'react';
import FinancialAnalytics from '../../components/analytics/FinancialAnalytics';

const FinancialPage = () => {
    return (
        <div className="p-6 space-y-10 max-w-screen-xl mx-auto">
            <FinancialAnalytics/>
        </div>
    );
};

export default FinancialPage;
